import React from 'react';
import Delete from '@material-ui/icons/Delete';
import ContributeKrComp from '../wizard/key_results/contribute-kr.component';
import { PageScrollVisible, SetKrContainerHeight } from '../../../utils/function';
import GoalServices from '../../../services/goal.services';
import { withTranslation } from 'react-i18next';
import { Modal, ThemeProvider, ModalWrapper, ModalHeader, ModalContent, IconButton } from '@workboard/wobo-ui';
import styled from "styled-components"
import ReactDOM from 'react-dom';

const StyledModal = styled(Modal)`
  .MuiDialog-scrollPaper {
    justify-content: flex-end;
    height: 100%;
  }

  ${ModalWrapper} {
    width: 50%;
    height: 100%;
    min-width: 760px;
    margin: 0;
  }
  ${ModalHeader} {
    padding: 58px 100px 12px 60px !important;
    h1 {
      font-size: 20px !important;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
  ${ModalContent} {
    padding: 0px 107px 0px 60px !important;
    height: calc( 100% - 190px );
    overflow: auto;
    p {
       line-height: 1.5;
       margin: 0;
    }
  }
`;

const StyledDeleteModal = styled(Modal)`
  ${ModalWrapper} {
    width: 465px;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} {
    padding: 20px !important;
    p {
       line-height: 1.5;
       margin: 0;
    }
  }
`;

const DeleteKRButton = (props) => {
	return(
		<IconButton
			style={{marginRight: 10, width: '30px', height: '30px'}}
			onClick={() => props.handleDeleteOpenModal()}
		>
      <Delete />
    </IconButton>
	)
}

class KrModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteConfirmModal: false,
    };
    this.currentComp = React.createRef();
    this.triggerSave = this.triggerSave.bind(this);
    this.deleteKR = this.deleteKR.bind(this);

    this.handleDeleteOpenModal = this.handleDeleteOpenModal.bind(this);
    this.handleDeleteCloseModal = this.handleDeleteCloseModal.bind(this);

    this.GoalServices = new GoalServices();
  }

  componentDidMount() {
    SetKrContainerHeight();
  }

  componentWillUnmount() {
    PageScrollVisible(true);
  }

  handleDeleteOpenModal() {
    this.setState({ deleteConfirmModal: true });
  }

  handleDeleteCloseModal() {
    this.setState({ deleteConfirmModal: false });
  }

  deleteKR() {
    let _this = this;
    let { cascadeMetric } = this.props.data;
    let metricId = cascadeMetric.id;
    if (metricId) {
      this.GoalServices.deleteCascadeUserMetric({ metricId })
        .then(() => {
          _this.props.handleCloseModal();
          _this.reloadMyOkrPage();
          triggerNotificationTry();
        });
    }
  }

  reloadMyOkrPage() {
    if ($('#goal_index_page').length) {
      if(typeof window.MyGoalContainer !== 'undefined'){
        let { cascadeMetric } = this.props.data;
        let metricId = cascadeMetric.id;
        window.MyGoalContainer.updateGoalItems({action: 'deleteCascadeKr',goalId: cascadeMetric.cascade_goal_id,metricId: metricId});
      }
    }
  }

  getParent() {
    return document.getElementById('page');
  }

  triggerSave() {
    if (this.currentComp) {
      if (typeof this.currentComp.current.triggerSave === 'function') {
        this.currentComp.current.triggerSave();
      }
    }

    const channel = new BroadcastChannel('okr:keyResult:cascadeAccepted');
    channel.postMessage({ action: 'cascadeAccepted' });
  }

  getDeleteConfirmParent() {
    return document.getElementById('keyresult-comp-wrapper');
  }

  render() {
    const { t } = this.props;
    return (
      <ThemeProvider>
        <StyledModal
            dismissLabel={t("Cancel")}
            submitLabel={t("Save")}
            isOpen={this.props.isOpen}
            onDismiss={this.props.handleCloseModal}
            onSubmit={this.triggerSave}
            removeClose
            title={`${t('Create Cascaded Key Result')}`}
            className="cascade-modal"
            toolbar={() => <DeleteKRButton handleDeleteOpenModal={this.handleDeleteOpenModal} />}
            style={{ zIndex: '1000000', padding: 0, alignItems: 'flex-end', flexDirection: 'column' }}
          >
            <div className="keyresult-comp-wrapper" id="keyresult-comp-wrapper">
                <div className="kr-modal-header">
                    <div className="width100">
                        <div className="kr-header-remove right">

                          <StyledDeleteModal
                            className="delete-comment"
                            dismissLabel={t("Cancel")}
                            submitLabel={t("Delete")}
                            isDanger
                            isOpen={this.state.deleteConfirmModal}
                            onDismiss={() => this.handleDeleteCloseModal()}
                            onSubmit={() => this.deleteKR()}
                            title={`${t('Delete Key Results')}`}
                          >
                            <p>{t('Are you sure you want to delete this key result? This cannot be undone.')}</p>
                          </StyledDeleteModal>
                          </div>
                        <div className="clear" />
                      </div>
                  </div>
                <div className="kr-modal-content">
                    <div className="kr-modal-content-inner">
                        <ContributeKrComp ref={this.currentComp} {...this.props} />
                      </div>
                  </div>
              </div>
          </StyledModal>
      </ThemeProvider>
    );
  }
}

const TranslatedKrModal = withTranslation()(KrModal)

export const openCascadeKrModal = (props) => {
  const { domElementId, unmount } = props;
  const domElement = document.getElementById(domElementId);
  if (domElement !== undefined && !unmount) {
    ReactDOM.render(<TranslatedKrModal {...props} />, domElement);
  }
}

if (window) {
  Object.defineProperty(window, 'openCascadeKrModal', {
    value: openCascadeKrModal,
  });
}

export default TranslatedKrModal
